import dagre from "dagre"

/**
 * Rebuilds a completed graph doing a depth-first-search and adding the leftmost
 * branches first, so dagre lays them out in the order we want
 *
 * @param {graphlib.Graph} initialGraph
 * @returns {graphlib.Graph} reconstructed graph with correct branch ordering
 */
const reconstructGraph = initialGraph => {
  const graph = new dagre.graphlib.Graph({ directed: true })
  graph.setGraph(initialGraph.graph())

  const visited = new Set()
  const entryNodes = initialGraph.sources().sort((a, b) => a - b)
  for (const entryNode of entryNodes) {
    // Add all entry nodes in the correct order to the new graph
    graph.setNode(entryNode, initialGraph.node(entryNode))
    // Run DFS starting from entry nodes to reconstruct all branches
    dfsReconstruct(initialGraph, graph, entryNode, visited)
  }
  return graph
}

const dfsReconstruct = (inputGraph, outputGraph, nodeId, visited) => {
  // Check that we haven't visited this node already
  if (visited.has(nodeId)) return
  visited.add(nodeId)

  // Get the edges from the current node, sorted from left to right...
  const edges = sortedEdges(inputGraph.outEdges(nodeId), inputGraph)
  for (const edge of edges) {
    //...add every node and edge to the new graph...
    outputGraph.setNode(edge.nodes.w, inputGraph.node(edge.nodes.w))
    outputGraph.setEdge(edge.nodes.v, edge.nodes.w, edge.meta)
    // ...and recursively continue reconstructing the graph starting from that node.
    dfsReconstruct(inputGraph, outputGraph, edge.nodes.w, visited)
  }
}

const sortedEdges = (edges, inputGraph) => {
  // Extract the metadata we stored in the input graph's edge (weight, condition)
  let loadedEdges = edges.map(e => {
    return { nodes: e, meta: inputGraph.edge(e) }
  })

  if (loadedEdges.length < 2) return loadedEdges

  // Reorder the edges with the "yes" edge first for condition nodes
  if (loadedEdges[0].meta.condition) {
    loadedEdges = loadedEdges.sort(a => (a.meta.condition == "yes" ? -1 : 1))
  }
  return loadedEdges
}

export default reconstructGraph
